import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={styles["myhouse_main_price--more"] || "myhouse_main_price--more"} width="7" height="18" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M.222 3.222a.756.756 0 01.984-.074l.085.074 5.244 5.243a.756.756 0 01.073.985l-.073.085-5.244 5.243a.756.756 0 01-1.143-.984l.074-.085L4.93 9 .222 4.291a.756.756 0 01-.074-.985l.074-.084z" fill="#6D7075" fillRule="nonzero" /></svg>);